'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DoubleRightOutlined = _interopRequireDefault(require('./lib/icons/DoubleRightOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _DoubleRightOutlined;
exports.default = _default;
module.exports = _default;